export default {
  brand: {
    name: '福海国际',
    fullName: '福海通达国际机械（苏州）有限公司',
    description: '作为农业机械领域的领先制造商，专注于拖拉机和农业设备。我们为现代农业提供创新解决方案，整合研发、生产、销售和服务。',
    address: '苏州工业园区汀兰巷183号沙湖科技园1号楼210室',
    productionBase: '山东省潍坊市坊子区坊城街道辛庄村委北',
    phone: '+86 15206211582',
    email: 'sales@fuhai-intl.com',
    addressLabel: '地址：',
    productionBaseLabel: '生产基地：'
  },
  copyright: '版权所有©2016 福海通达国际机械（苏州）有限公司 保留所有权利',
  language: '中文',
  banner: {
    company_name: '福海国际',
    tagline1: '创新福海',
    tagline2: '达沃天下',
    tagline3: '科技改变农业未来'
  },
  footer: {
    followUs: '关注我们'
  },
  social: {
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    twitter: 'Twitter'
  }
}; 